// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2455":"f530be48","3404":"f530be48","7735":"74175408","9025":"74175408"}[chunkId] + ".chunk.css";
};